import { render, staticRenderFns } from "./TriggerDetail.vue?vue&type=template&id=7ecbc9d9&scoped=true"
import script from "./TriggerDetail.vue?vue&type=script&lang=js"
export * from "./TriggerDetail.vue?vue&type=script&lang=js"
import style0 from "./TriggerDetail.vue?vue&type=style&index=0&id=7ecbc9d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecbc9d9",
  null
  
)

export default component.exports